import React from 'react';
import { Table } from 'antd';

import Img from '../../../../components/Img';
import noneExpandedArrow from '../../../../static/images/common/arrow_bottom_outline_black_w24_btn.png';
import expandedArrow from '../../../../static/images/common/arrow_top_outline_black_w24_btn.png';
import { columns } from './columns';
import './ExhibitCategoryTable.scss';

const ExhibitCategoryTable = (props) => {
  const { exhibitCategoryDataSource } = props;

  return (
    <div className="exhibit-category-table-wrap">
      <Table
        rowKey={(record) => record.id}
        columns={columns()}
        dataSource={exhibitCategoryDataSource}
        pagination={false}
        scroll={{ y: 'calc(100vh - 320px)' }}
        showHeader={false}
        rowClassName={(record) => record?.children?.length && 'contain-sub-category'}
        expandRowByClick
        expandIcon={({ expanded }) =>
          expanded ? (
            <Img className="row-expand-icon" clickAble={false} src={expandedArrow} />
          ) : (
            <Img className="row-expand-icon" clickAble={false} src={noneExpandedArrow} />
          )
        }
      />
    </div>
  );
};

export default ExhibitCategoryTable;
